export default __webpack_public_path__ + "static/media/auction-placeholder.e9293500.jpg";